import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Button, Select} from '../../ui';

import visa from '../../../assets/common/payment/icon-visa.png';
import oca from '../../../assets/common/payment/icon-oca.png';
import master from '../../../assets/common/payment/icon-master.png';
import checkoutIcon from '../../../assets/common/payment/checkout-icon.png';

import { paymentConfig } from '../../../ecosystem.config';
import {
  setPaymentValue,
  setInstallments,
  setStepInnerPage,
} from '../../../actions';
import { payment } from '../../../operations';
import { numberWithDots } from '../../../helpers';

class Checkout extends Component {

  constructor(props) {
    super(props);

    const { currency } = this.props;

    this.state = {
      currency: currency === 'UYU' ? '$' : currency === 'USD' ? 'U$S' : '',
      renderFinish: false,
    };

    this.handleContinueClick = this.handleContinueClick.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const {
      fees, installments,
      handleInstallmentsSelect
    } = this.props;
    
    let fee0 = fees && fees[0] ? fees[0] : 0;
    if (fee0 && installments && !installments.amount) handleInstallmentsSelect(fee0);
  }

  componentDidMount() {
    //Warning: unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.
    setTimeout(() => { this.setState({ renderFinish: true }) }, 1500);
  }

  handleContinueClick() {

    const { 
      paymentType, 
      setStepInnerPage,
      openSiemprePagoModal,
      quoterData,
      currency,
      handleRed
    } = this.props;

    switch (paymentType) {
      case 'red':
        setStepInnerPage('paymentMessage');
        handleRed(quoterData, currency);
        break;
      //case 'debit':
      //  setStepInnerPage('paymentDebit');
      //  break;
      case 'credit':
        openSiemprePagoModal();
        break;
    };
  };

  render() {

    const { currency, renderFinish } = this.state;

    const {
      fees, paymentType, handleSelect,
      handleInstallmentsSelect
    } = this.props;
    
    let { quoter, config, installments } = this.props;
    if (quoter && quoter !== '') config = quoter;

    let fee0 = fees && fees[0] ? fees[0] : 0, fee;
    if (paymentType === 'debit') fee = fee0; else fee = installments;

    return (
      <div>
        <div className="Checkout">
          <div>
            <div className="Checkout-icon">
              <img src={checkoutIcon} alt="" />
            </div>
          </div>
          <div>
            <div className="Checkout-wrapper">
              <h3 style={{ marginBottom: 22 }}>¿Cómo te gustaría pagarlo?</h3>
              <div className="Checkout-cards">
                {paymentConfig[config].red &&
                  <div className="Card" onClick={() => handleSelect('red')} style={{ fontWeight: 800 }}>
                    <span className={`Card-radio ${paymentType === 'red' ? 'Card-radio--on' : ''}`}></span>
                    <div className="Card-logo">
                      <span>Redes de cobranza / Pago en línea / Paganza</span>{' '}
                    </div>
                  </div>
                }
                {paymentConfig[config].debit &&
                  <div className="Card" onClick={() => handleSelect('debit')} style={{ fontWeight: 800 }}>
                    <span className={`Card-radio ${paymentType === 'debit' ? 'Card-radio--on' : ''}`}></span>
                    <div className="Card-logo">
                      <span>Pago con Débito Automático</span>{' '}
                    </div>
                  </div>
                }
                {(paymentConfig[config].visa || paymentConfig[config].master || paymentConfig[config].oca) &&
                  <div className="Card" /*Card--disabled*/ onClick={() => handleSelect('credit')}>
                    <span className={`Card-radio ${paymentType === 'credit' ? 'Card-radio--on' : ''}`}></span>
                    <div className="Card-logo">
                      {paymentConfig[config].visa && <img src={visa} alt="Visa" style={{ maxWidth: 90 }} />}
                      {paymentConfig[config].master && <img src={master} alt="Mastercard" style={{ maxWidth: 90 }} />}
                      {paymentConfig[config].oca && <img src={oca} alt="Oca" style={{ maxWidth: 90 }} />}
                    </div>
                  </div>
                }
              </div>
              {paymentType != 'debit' &&
                <div className="Checkout-installments">
                  <h3 style={{ marginBottom: 8 }}>Cantidad de cuotas:</h3>
                  <Select
                    clearable={false}
                    value={installments}
                    onChange={handleInstallmentsSelect}
                    style={{ 'fontSize': '16px' }}
                    options={fees}
                  />
                </div>
              }

              {fee &&
                <div className="Checkout-installments">
                  <h3 style={{ marginBottom: 8 }}>{`Importe Total: ${currency} ${numberWithDots(fee.amount)}`}</h3>
                </div>
              }
            </div>
          </div>
        </div>
        <div className="Checkout-contract Checkout-footer">
          {paymentType === 'credit' &&
            <p>Al presionar el botón de Contratar, se abrirá un pop up de Siempre Pago para realizar el pago de forma segura.</p>
          }
          <Button onClick={this.handleContinueClick} disabled={!fee.amount || !renderFinish}>
            Contratar
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paymentType: state.payment.paymentType,
    installments: state.payment.installments,
    fees: state.quotation.optionalSelected ? state.quotation.feesOptional : state.quotation.fees,
    quoter: state.options.quoter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleSelect: (name) => {
      dispatch(setPaymentValue('paymentType', name));
    },
    handleInstallmentsSelect: (installments) => {
      dispatch(setInstallments(installments));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    openSiemprePagoModal: () => {
      dispatch(setPaymentValue('openSiemprePago', true));
    },
    handleRed: (quoterData, currency) => {
      dispatch(payment.quoterPurchaseNoCard(quoterData, currency));
    }
  };
};

Checkout.propTypes = {
  config: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
}

Checkout.defaultProps = {
  config: 'Default',
  currency: 'UYU',
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
